import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ spacing, palette }: Theme) => ({
  container: {
    display: 'flex',
    flex: '1',
    height: '100%',
  },

  containerRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& > div': {
      color: palette.neutral[100],
      marginBottom: spacing(2),
    },
  },

  info: {
    color: palette.grey[400],
    whiteSpace: 'nowrap',
    marginTop: spacing(2),
    '& > div': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },

  image: {
    width: '100%',
    height: '100%',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  },
}));

export default useStyles;
